import { Controller } from "@hotwired/stimulus"

// Schedule only: this never fetches status, claims "live now", or controls playback.
export default class extends Controller {
  static targets = ["countdown", "label", "status"]
  static values = { nextLiveShow: String, window: Number, grace: Number, showId: Number, excludeShowId: Number }

  connect() {
    if (!this.nextLiveShowValue) return
    this.startsAt = Date.parse(this.nextLiveShowValue)
    this.update()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  scheduleChanged({ detail }) {
    this.showIdValue = detail.showId || 0
    this.nextLiveShowValue = detail.startsAt
    this.startsAt = Date.parse(detail.startsAt)
    this.update()
  }

  update() {
    clearTimeout(this.timer)
    if (!this.nextLiveShowValue) return
    const remaining = this.startsAt - Date.now()
    const grace = this.graceValue
    const replay = Boolean(this.showIdValue && this.showIdValue === this.excludeShowIdValue)
    this.element.hidden = replay || remaining <= -grace || remaining > this.windowValue
    this.element.dataset.started = String(remaining <= 0)
    this.statusTargets.forEach(target => { target.textContent = remaining <= 0 ? "Scheduled start reached" : "Scheduled soon" })
    this.labelTargets.forEach(target => { target.textContent = remaining <= 0 ? "Delayed start" : "Upcoming · in" })
    if (remaining <= 0) {
      this.countdownTargets.forEach(target => { target.textContent = "" })
      if (!this.element.hidden) this.timer = setTimeout(() => this.update(), remaining + grace)
      return
    }

    if (!this.element.hidden) {
      const minutes = Math.ceil(remaining / 60000)
      const countdown = `${Math.floor(minutes / 60)}h ${minutes % 60}m`
      this.countdownTargets.forEach(target => { target.textContent = countdown })
    }

    const delay = remaining > this.windowValue
      ? remaining - this.windowValue
      : this.countdownTargets.length ? Math.min(remaining, remaining % 60000 || 60000) : remaining
    this.timer = setTimeout(() => this.update(), Math.min(delay, 2_147_483_647))
  }
}
